import { render } from "./HomeFaqItem.vue?vue&type=template&id=d8cfd826"
import script from "./HomeFaqItem.vue?vue&type=script&lang=js"
export * from "./HomeFaqItem.vue?vue&type=script&lang=js"

import "./HomeFaqItem.vue?vue&type=style&index=0&id=d8cfd826&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__